export enum CreateEventStage {
  Space = 'SPACE',
  Type = 'TYPE',
  Details = 'DETAILS',
  Communications = 'COMMUNICATIONS',
  Preview = 'PREVIEW',
}
